import React, { FC } from "react";
import { Maybe } from "graphql/jsutils/Maybe";
import { ProductImage } from "@pepdirect/v3/ui/ProductImage";
import { Heading } from "@pepdirect/v3/ui/Heading";

import { StyledDetails, StyledQuantity, StyledWrapper } from "./index.styled";

interface FulfillmentItemProps {
  item: {
    quantity?: number | null;
    item?: Maybe<{
      title?: string | null;
      imgUrl?: string | null;
    }>;
  } | null;
}

export const FulfillmentItemProduct: FC<FulfillmentItemProps> = ({
  item: fulfillmentItem = {},
}) => {
  if (!fulfillmentItem) return null;
  const { item, quantity } = fulfillmentItem;

  if (!item) return null;
  const { title, imgUrl } = item;
  return (
    <StyledWrapper>
      <ProductImage alt="fulfillment item" size={60} src={imgUrl || "/"} />
      <StyledDetails>
        <Heading level="h3" size="xs">
          {title}
        </Heading>
        <StyledQuantity>Quantity: {quantity}</StyledQuantity>
      </StyledDetails>
    </StyledWrapper>
  );
};
